module.exports = __webpack_public_path__ + "img/passion_prive.990b0020.png";